export const eventsConstants = {
  GET_EVENTS: "GET_EVENTS",
  CANCEL_EVENT: "CANCEL_EVENT",
  VIEW_EVENT_SHUTTERBS: "VIEW_EVENT_SHUTTERBS",
  REASSIGN_SHUTTERBS: "REASSIGN_SHUTTERBS",
  GET_EVENT_GALLERY: "GET_EVENT_GALLERY",
  DOWNLOAD_GALLERY_DATA: "DOWNLOAD_GALLERY_DATA",
  DELETE_FROM_GALLERY: "DELETE_FROM_GALLERY",
  FAVORITE_GALLERY_CLIP: "FAVORITE_GALLERY_CLIP",
  ADD_TO_GALLERY: "ADD_TO_GALLERY",
  GET_EVENT_DETAIL_BY_ID: "GET_EVENT_DETAIL_BY_ID",
  EVENT_NAME_NOT_AVAILABLE: "Event Name Not Available",
  EVENT_GROUP_NAME_NOT_AVAILABLE: "Event Group Name Not Available",
  INVALID_INPUT: "Invalid input to getEndOfDayUnixTimestamp",
  UPCOMING_EVENTS_DEFAULT_ORDER_BY_EXPRESSION: "CreatedAt desc",
  COMPLETED_EVENTS_DEFAULT_ORDER_BY_EXPRESSION: "EventDate desc",
  CANCELLED_EVENTS_DEFAULT_ORDER_BY_EXPRESSION: "EventDate desc",
};

export const eventsStatusConstants = {
  PENDING: "pending",
  CREATED: "created",
  ACCEPTED: "accepted",
  CHECKOUT: "checkOut",
};

export const QUESTION_TYPE_IDS = {
  CONTENT_USAGE: 21,
  BRAND_GUIDELINES: 9,
  ADD_RECAP_PURPOSE: 6,
};

export const eventsSortingOptions = [
  {
    NAME: "Event date Asc",
    SELECTOR: "EventDate asc",
  },
  {
    NAME: "Event date Desc",
    SELECTOR: "EventDate desc",
  },
  {
    NAME: "Created at Asc",
    SELECTOR: "CreatedAt asc",
  },
  {
    NAME: "Created at Desc",
    SELECTOR: "CreatedAt desc",
  },
];
